import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Component as ErrorBoundary } from "@/components/ErrorBoundary";
import { VisitTracker } from "@/components/VisitTracker";
import { FloatingCoupon } from "@/components/FloatingCoupon";
import Home from "@/pages/Home";
import { scrollToSection } from "@/lib/scroll";

const MenuPage = lazy(() => import("@/pages/Menu"));
const Legal = lazy(() => import("@/pages/Legal"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));

const PageFallback = () => <div className="min-h-screen bg-[#050505]" />;

const lazyEl = (node) => (
  <Suspense fallback={<PageFallback />}>{node}</Suspense>
);

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LenisInit() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisInit />
        <ScrollManager />
        <VisitTracker />
        <FloatingCoupon />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={lazyEl(<MenuPage />)} />
          <Route path="/privacy" element={lazyEl(<Legal type="privacy" />)} />
          <Route path="/cookie-policy" element={lazyEl(<Legal type="cookie" />)} />
          <Route path="/admin" element={lazyEl(<AdminPage />)} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
